import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable()
export class StoryContainerService {

  constructor() { }

  reloadStoryAndElements(storyData:any,viewPortItems:any,initialElementCount:any)
  {
    if (storyData['elements'] && (storyData['elements'].length > 0)) {
      viewPortItems = Object.assign(viewPortItems, (
        (storyData['elements'].length > initialElementCount)
          ? storyData['elements'].slice(0, initialElementCount)
          : storyData['elements']));
    }
  }

  retainStoryData(storyData:any,storyDataToRestore:any)
  {
    if(storyDataToRestore && storyData)
    {
      storyData.lastModifiedBy = storyDataToRestore.lastModifiedBy;
      storyData.lastModifiedByUserName = storyDataToRestore.lastModifiedByUserName;
      storyData.lastModifiedDate = storyDataToRestore.lastModifiedDate;
      storyData.lastPublishedBy = storyDataToRestore.lastPublishedBy;
      storyData.lastPublishedDate = storyDataToRestore.lastPublishedDate;
      storyData.firstPublishedDate = storyDataToRestore.firstPublishedDate;
      storyData.lockedByUserId = storyDataToRestore.lockedByUserId;
      storyData.lockedByUserName = storyDataToRestore.lockedByUserName;
      storyData.lockedDate = storyDataToRestore.lockedDate;
      if(storyDataToRestore.metadata && storyData.metadata)
      {
        storyData.metadata.status = storyDataToRestore.metadata.status;
        storyData.metadata.editedBy = storyDataToRestore.metadata.editedBy;
        storyData.metadata.writtenBy = storyDataToRestore.metadata.writtenBy;
        storyData.metadata.authorsList = storyDataToRestore.metadata.authorsList;
        storyData.metadata.postedByList = storyDataToRestore.metadata.postedByList;
        storyData.metadata.editedByList = storyDataToRestore.metadata.editedByList;
        storyData.metadata.writtenByList = storyDataToRestore.metadata.writtenByList;
        storyData.metadata.reportedByList = storyDataToRestore.metadata.reportedByList;
        storyData.metadata.ampStatus = storyDataToRestore.metadata.ampStatus;
        storyData.metadata.killed = storyDataToRestore.metadata.killed;
        storyData.metadata.killedStatusCode = storyDataToRestore.metadata.killedStatusCode;
      }
      storyData.scheduledDate = storyDataToRestore.scheduledDate;
      storyData.scheduledAt = storyDataToRestore.scheduledAt;
      storyData.webEngageScheduledAt = storyDataToRestore.webEngageScheduledAt;
      storyData.webEngageScheduledDate = storyDataToRestore.webEngageScheduledDate;
      storyData.scheduledBy = storyDataToRestore.scheduledBy;
      storyData.embargoDate = storyDataToRestore.embargoDate;
      storyData.embargoAt = storyDataToRestore.embargoAt;
      storyData.embargoBy = storyDataToRestore.embargoBy;
      storyData.readByUsers = storyDataToRestore.readByUsers;
      storyData.expiryDate = storyDataToRestore.expiryDate;
      storyData.expireAt = storyDataToRestore.expireAt;
      storyData.changesPublished = storyDataToRestore.changesPublished;
      storyData.softPublished = storyDataToRestore.softPublished;
      storyData.lastRequestId = storyDataToRestore.lastRequestId;
      storyData.webengageNotificationTitle = storyDataToRestore.webengageNotificationTitle;
      storyData.topicMigrated = storyDataToRestore.topicMigrated;
      storyData.migrationInfoWebUrl = storyDataToRestore.migrationInfoWebUrl;
      storyData.migrationInfoWebUrlMigrated = storyDataToRestore.migrationInfoWebUrlMigrated;
      storyData.topicPublished = storyDataToRestore.topicPublished;
      storyData.migrationInfoWebUrlPublished = storyDataToRestore.migrationInfoWebUrlPublished;
      storyData.autoPublished = storyDataToRestore.autoPublished;
    }
  }
}
